import { observable, action, toJS } from "mobx";
import { Injectable } from "@angular/core";
import * as XLSX from 'xlsx';
import * as moment from "moment";
import { DataService } from "../services/data.service";
import { MappingService, pushToArray, pushToObject, toCapitalize } from "../services/mapping.service";
import { AngularFirestoreCollection } from "@angular/fire/firestore";
import { GENDER_DATA } from "../dummy/status";
import { ConvertService } from "../services/convert.service";
type AOA = any[];

@Injectable({ providedIn: 'root' })
export class ExcelStore {
  @observable public data = [];
  @observable public students = [];
  @observable public xlcData = [];
  @observable public selectedXlcData = [];
  @observable public loading = false;
  @observable public process = false;
  @observable public empty = true;
  @observable public isexist = false;
  @observable public ExlPost = null;

  @observable public InvalidDate = false;
  @observable public InvalidVillage = false;
  @observable public InvalidPartyGroup = false;
  @observable public InvalidPartyGroupPosition = false;
  @observable public InvalidPartyFamily = false;
  @observable public InvalidPartyFamilyPosition = false;

  @observable excelData: AOA = [];
  writingOptions: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName: string = 'auxswot-cloud.xlsx';
  selectedFiles: FileList;

  constructor(private ds: DataService) { }



  @action
  async fetchList(ref: AngularFirestoreCollection) {
    const docs = await ref.get().toPromise();
    return pushToArray(docs);
  }

  @action
  unsubscribe() {
    this.data = [];
    this.xlcData = []
    this.excelData = [];
    this.InvalidVillage = false;
    this.InvalidVillage = false;
    this.isexist = false;
    this.InvalidPartyGroup = false;
    this.InvalidPartyGroupPosition = false;
    this.InvalidPartyFamily = false;
    this.InvalidPartyFamilyPosition = false;
  }

  validDob(dob: any) {
    if (!dob) return null;
    if (dob instanceof Date) {
      return dob
    }
    const getDob = dob.match(/[^~/-]+/g);
    let DateArray = [
      '01',
      '01',
    ]
    if (getDob.length === 1) {
      DateArray.push(getDob);
      return moment(DateArray, "DD-MM-YYYY").toDate();
    }
    const sDob = getDob.map((f, index) => {
      if (index === 1 && Number(f) > 12) return '01'
      return f
    })
    const toDate = moment(sDob, "DD-MM-YYYY").toDate();
    return toDate
  }

  validPartyNo(p1, p2) {
    const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

    if (!p1 && !p2) return 'គ្មាន';
    if (p1 === 'P' || p2 === 'P') return 'P';
    if (p1 === 'បាត់' || p2 === 'បាត់') return 'បាត់';
    if (p1 === 'គ្មាន' && p2 === 'គ្មាន') return 'គ្មាន';
    if (p1 && !p2) {
      const pp = p1 instanceof Date
      return pp ? 'P' : p1
    }
    if (p2 && !p1) {
      const pp = p2 instanceof Date
      return pp ? 'P' : p2
    }

    if (p1 !== 'បាត់' && p1 !== 'គ្មាន' && p2 !== 'បាត់' && p2 !== 'គ្មាន') {
      const sp1 = format.test(p1);
      const sp2 = format.test(p2);
      if (p1 && p2) {
        if (sp1) return p2
        if (sp2) return p1
      }
      if (p1 && !p2) {
        const pp = p1 instanceof Date
        return pp ? 'P' : p1
      }
      if (p2 && !p1) {
        const pp = p2 instanceof Date
        return pp ? 'P' : p2
      }

    }
    return 'P'
  }

  isValidVillage(v1: string, v2: string) {
    if (v1 && v2) {
      return v1.trim() === v2.trim() ? true : false
    } return true
  }
  isValidDate(d) {
    return d instanceof Date && isFinite(d as any)
  }

  ExcelDateToJSDate(serial) {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);

    var fractional_day = serial - Math.floor(serial) + 0.0000001;

    var total_seconds = Math.floor(86400 * fractional_day);

    var seconds = total_seconds % 60;

    total_seconds -= seconds;

    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;

    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
  }

  @action
  async fileCamReadingChange(evt: any) {
    this.process = true;
    this.excelData = [];
    this.xlcData = []
    this.selectedFiles = evt.target.files;
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      this.excelData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      //remove header
      if (this.excelData.length > 1) {
        this.excelData = this.excelData.slice(1, this.excelData.length)

        Promise.all(
          this.excelData.map(async m => {
            // const id: any = `${m[2]}`.length === 8 ? `${m[2]}` : `00000000`.substring(0, 8 - `${m[2]}`.length) + `${m[2]}`

            const ID = m[0]
            const studentDoc = await this.ds.dbRef().collection("students", ref => ref.where("studentId", "==", ID)).get().toPromise()
            const studentData = pushToArray(studentDoc)
            const student = studentData[0]
            let isExit: boolean = false
            if (student && student.key) {
              const { batchKey } = student
              const batches = await this.ds.dbRef().collection('reading_batches', ref => ref.where('academicYear.key', '==', 'xETBDyZzFfyeiV92BFMO')).get().toPromise()
              const batchData = pushToArray(batches)
              const df = batchData.filter(m => m.key === batchKey)
              isExit = df.length > 0 ? true : false;
            }
            this.xlcData.push(
              {
                ID: ID,
                LastName: m[1],
                FirstName: m[2],
                Gender: m[3],
                Class: m[4],
                isExist: isExit,

                // isExist: studentData && studentData.length > 0 ? true : false,
              }
            )
          })
        )

      }
      this.process = false;
    };
    await reader.readAsBinaryString(target.files[0]);
  }

  @action
  async importStudentCamReading(items: Array<any>, form: any, user: any, callback) {
    this.process = true;
    const { organization, reading_batch, year } = form

    items.forEach(async (item, index) => {
      const { FirstName, LastName, Gender, ID } = item;

      const batchData = reading_batch
      const batch = this.ds.batch();
      const studentRef = this.ds.firestore().collection("students")
      const orgRef = this.ds.firestore().collection("organizations").doc(organization.key)
      const studentArray = pushToArray(await this.ds.studentsRef(ref => ref.where('studentId', '==', ID)).get().toPromise())

      const studentDoc = studentArray[0]

      const licenceKey = this.ds.createId()
      const licenceData = {
        key: licenceKey,
        academicYear: MappingService.yearObj(year),
        accountType: { key: 1, router: "students", text: "Students" },
        batchKey: batchData.key,
        batchData: {
          key: batchData.key,
          name: batchData.name,
        },
        batchRef: this.ds.dbRef().collection("reading_batches").doc(batchData.key).ref,
        currentReadingLevel: 0, //Level
        licenceKey: licenceKey,
        licenceOption: { key: "one_year", month: 12, name: "One year" },
        memberCreatedDate: new Date(),
        memberExpiredDate: moment(new Date()).add(1, 'years').toDate(),
        organizationKey: organization.key,
        organization: {
          key: organization.key,
          name: organization.name,
          khmerName: organization.khmerName
        },
        organizationRef: orgRef,
        pendingJoinClass: false,
      }
      if (studentDoc && studentDoc.key) {
        console.log('studentDoc', studentDoc);
        const studentData = {
          batchKey: batchData.key,
          batchRef: this.ds.dbRef().collection("reading_batches").doc(batchData.key).ref,
          licenceKey: licenceKey,
          licenceOption: { key: "one_year", month: 12, name: "One year" },
          memberCreatedDate: new Date(),
          memberExpiredDate: moment(new Date()).add(1, 'years').toDate(),
          status: { key: 1, text: "Active" },
          organizationKey: organization.key,
          organizationRef: orgRef,
        }
        const batchStudentData = {
          batchKey: batchData.key,
          batchRef: this.ds.dbRef().collection("reading_batches").doc(batchData.key).ref,
          key: licenceKey,
          memberCreatedDate: new Date(),
          memberExpiredDate: moment(new Date()).add(1, 'years').toDate(),
          studentData: {
            fullName: `${toCapitalize(LastName)} ${toCapitalize(FirstName)}`,
            gender: studentDoc.gender,
            studentId: ID,
            phoneNumber: studentDoc.phoneNumber,
          },
          studentKey: studentDoc.key,
          studentRef: this.ds.dbRef().collection("students").doc(studentDoc.key).ref,
        }

        // // console.log('licenceData', toJS(licenceData));
        // // console.log('studentData', toJS(studentData));
        // // console.log('batchStudentData', toJS(batchStudentData));

        batch.update(studentRef.doc(studentDoc.key), studentData);
        batch.set(studentRef.doc(studentDoc.key).collection("licences").doc(licenceData.key), licenceData);

        batch.set(orgRef.collection("students").doc(batchStudentData.key), batchStudentData);
        batch.set(orgRef.collection("reading_batches").doc(batchData.key), batchData);
        batch.set(orgRef.collection("reading_batches").doc(batchData.key).collection("students").doc(batchStudentData.key), batchStudentData);

        // const helo = pushToArray(await this.ds.dbRef().collection('students').doc(studentDoc.key).collection('licences').get().toPromise())
        // const filter = helo.filter(m => m.batchKey === batchData.key)
        // filter.forEach(element => {
        //   if (element && element.key) {
        //     batch.delete(studentRef.doc(studentDoc.key).collection("licences").doc(element.key));

        //     batch.delete(orgRef.collection("students").doc(element.key));
        //     batch.delete(orgRef.collection("reading_batches").doc(batchData.key));
        //     batch.delete(orgRef.collection("reading_batches").doc(batchData.key).collection("students").doc(element.key));
        //   }
        // });

        await batch.commit().then(() => {
          // console.log('done');
        })

        if (index + 1 === items.length) {
          console.log('done');

          this.process = false;
          this.selectedFiles = null;
          this.excelData = [];
          callback(true, null);
        }



      } else {
        console.log('no StudentDoc');
        const phoneData = item.Phone ? `0${ConvertService.toNumber(item.Phone)}` : null;
        const studentKey = this.ds.createId();
        const studentData = {
          key: studentKey,
          created_at: new Date(),
          created_by: user.key,
          created_byRef: this.ds.dbRef().collection("users").doc(user.key).ref,
          updated_at: new Date(),
          updated_by: user.key,
          updated_byRef: this.ds.dbRef().collection("users").doc(user.key).ref,
          date_key: ConvertService.dateKey(),
          keyword: `${toCapitalize(LastName)} ${toCapitalize(FirstName)} ${phoneData}`,
          page_key: ConvertService.pageKey(),

          accountType: { key: 1, router: "students", text: "Students" },
          apps: null,
          audiobook_completed: 0,
          batchData: null,

          batchKey: batchData.key,
          batchRef: this.ds.dbRef().collection("reading_batches").doc(batchData.key).ref,
          book_completed: 0,
          currentReadingLevel: 0,
          current_book: null,
          dateOfBirth: null,
          displayName: `${toCapitalize(LastName)} ${toCapitalize(FirstName)}`,
          email: null,
          firstName: toCapitalize(FirstName),
          fullName: `${toCapitalize(LastName)} ${toCapitalize(FirstName)}`,

          gender: Gender === "Female" ? { key: 0, en_name: "Female", text: "Female" } : { key: 1, en_name: "Male", text: "Male" },
          hasAlertExpired: false,
          isDelete: false,
          lastName: toCapitalize(LastName),

          licenceKey: licenceKey,
          licenceOption: { key: "one_year", month: 12, name: "One year" },
          memberCreatedDate: new Date(),
          memberExpiredDate: moment(new Date()).add(1, 'years').toDate(),
          memberId: null,

          organizationKey: organization.key,
          organizationRef: orgRef,
          package: { key: 0, router: "free", text: "Free" },
          pendingJoinClass: false,
          phoneNumber: phoneData,
          photoFileDetail: null,

          quiz_completed: 0,
          read_duration: 0,

          requestBatchRef: null,
          requestClassKey: null,
          requestedBatchKey: null,

          setting: null,
          status: { key: 1, text: "Active" },
          studentId: ID,
          totalMonth: null,
          total_audio_books: 0,
          total_books: 0,
          word_reads: 0
        }

        let genderData = null
        if (Gender === "Female") genderData = { key: 0, en_name: "Female", text: "Female" }
        else if (Gender === "Male") genderData = { key: 1, en_name: "Male", text: "Male" }
        else if (Gender === "F") genderData = { key: 0, en_name: "Female", text: "Female" }
        else genderData = { key: 1, en_name: "Male", text: "Male" }
        const batchStudentData = {
          batchKey: batchData.key,
          batchRef: this.ds.dbRef().collection("reading_batches").doc(batchData.key).ref,
          key: licenceKey,
          memberCreatedDate: new Date(),
          memberExpiredDate: moment(new Date()).add(1, 'years').toDate(),
          studentData: {
            fullName: `${toCapitalize(LastName)} ${toCapitalize(FirstName)}`,
            gender: genderData,
            studentId: ID,
            phoneNumber: phoneData,
          },
          studentKey: studentKey,
          studentRef: this.ds.dbRef().collection("students").doc(studentKey).ref,
        }

        // console.log('licenceData', toJS(licenceData));
        // console.log('studentData', toJS(studentData));
        // console.log('batchStudentData', toJS(batchStudentData));

        batch.set(studentRef.doc(studentData.key), studentData);
        batch.set(studentRef.doc(studentData.key).collection("licences").doc(licenceData.key), licenceData);

        batch.set(orgRef.collection("students").doc(batchStudentData.key), batchStudentData);
        batch.set(orgRef.collection("reading_batches").doc(batchData.key), batchData);
        batch.set(orgRef.collection("reading_batches").doc(batchData.key).collection("students").doc(batchStudentData.key), batchStudentData);

        await batch.commit().then(() => {
          // console.log('done');
        })

        if (index + 1 === items.length) {
          console.log('done');

          this.process = false;
          this.selectedFiles = null;
          this.excelData = [];
          callback(true, null);
        }
      }
    })


  }

  @action
  async partyMemberFileExcelChange(evt: any) {
    this.excelData = [];
    this.xlcData = [];
    this.selectedFiles = null;
    this.selectedFiles = evt.target.files;
    if (this.selectedFiles.length === 0) return;
    this.process = true;
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', cellText: false, cellDates: true });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.excelData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: "DD-MM-YYYY" }));

      if (this.excelData.length > 1) {
        this.excelData = this.excelData.slice(3, this.excelData.length)
        this.xlcData = []

        Promise.resolve(
          this.excelData = this.excelData.map(async (m: string[], index) => {

            const g = m[2];
            let gender = GENDER_DATA[0]
            if (g === 'ប' || g === 'ប្រុស') {
              gender = GENDER_DATA[0]
            }
            if (g === 'ស' || g === 'ស្រី') {
              gender = GENDER_DATA[1]
            }

            const fullName = m[1];
            if (!fullName) return;

            const gfn = fullName.toString()
            const gf = gfn && gfn != undefined ? gfn.trim().replace(/\s+/, " ") : '';
            const firstName = gf ? gf.split(' ').slice(1, 3).toString().replace(/,/g, " ").trim() : null;
            const lastName = gf ? gf.split(' ')[0].trim() : null;

            const dob = this.validDob(m[3])
            const dobText = m[3]
            const b_dob = this.validDob(m[15])
            const b_dobText = m[15]

            let isExist = false
            const idCardNo = m[5]
            if (idCardNo) {
              const eDocs = await this.ds.dbRef().collection("import_business_owner", ref => ref.where("idCardNo", "==", idCardNo)).get().toPromise();
              const eData = eDocs.docs.map((m: any) => { return { key: m.data().key } })
              isExist = eData.length > 0 ? true : false
            }

            const data = {
              isExist: isExist,
              full_name: fullName,
              last_name: lastName,
              first_name: firstName,
              gender: gender,
              dob: dob || null,
              dobText: dobText || null,
              nationality: m[4],
              idCardNo: idCardNo || null,
              contactNumber: m[6],
              province: m[7] || null,
              district: m[8] || null,
              commune: m[9] || null,
              village: m[10] || null,
              streetNo: m[11] || null,
              homeNo: m[12] || null,

              businessName: m[13] || null,
              businessType: m[14] || null,
              b_dob: b_dob || null,
              b_dobText: b_dobText || null,

              b_contactNumber: m[16],
              b_province: m[17] || null,
              b_district: m[18] || null,
              b_commune: m[19] || null,
              b_village: m[20] || null,
              b_streetNo: m[21] || null,
              b_homeNo: m[22] || null,

            }

            this.xlcData.push(data);

          })
        )

      }
      this.process = false;
    };
    reader.readAsBinaryString(target.files[0]);
  }

  // @action
  // async importBusinessOwner(items: Array<any>, f: any, selectedInspection: any, user: any, callback) {
  //   this.loading = true;

  //   items.forEach(async (m, index) => {
  //     const batch = this.ds.batch()
  //     const ref = this.ds.firestore().collection("import_business_owner")
  //     const { search, includeInInspection, officer, provinceInspection } = f

  //     const item = {
  //       ...m,
  //       key: this.ds.createId(),
  //       created_at: new Date(),
  //       date_key: ConvertService.dateKey(),
  //       created_by: user.key,
  //       status: DISPLAY_STATUS_OBJECT.ACTIVE,

  //       inspection: includeInInspection ? toInspection(selectedInspection) : null,
  //       inspectBy: includeInInspection ? toInspectionBy(officer) : null,
  //       includeInspection: includeInInspection,
  //       inspectProvince: provinceInspection ? MappingService.provinceObj(provinceInspection) : null,
  //     }
  //     batch.set(ref.doc(item.key), item)

  //     await batch.commit().then(() => { })

  //     if (index + 1 === items.length) {
  //       this.loading = false;
  //       this.xlcData = [];
  //       callback(true, null);
  //     }

  //   })

  // }

  getJsDateFromExcel(excelDateValue) {
    var date = new Date((excelDateValue - (25567 + 2)) * 86400 * 1000);
    var localTime = new Date(date.getTime() + (new Date()).getTimezoneOffset() * 60000);
    return localTime;
  }

  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    const file = target.files[0]
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', raw: true });
      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const data = <AOA>XLSX.utils.sheet_to_json(ws, { raw: false, dateNF: "yyyy-mm-dd" });

    };
    reader.readAsBinaryString(file);
  }


  @action
  async laborFileExcelChange(evt: any) {
    this.excelData = [];
    this.xlcData = [];
    this.selectedFiles = null;
    this.selectedFiles = evt.target.files;
    if (this.selectedFiles.length === 0) return;
    this.process = true;
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', cellText: false, cellDates: true });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.excelData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: "DD-MM-YYYY" }));

      if (this.excelData.length > 1) {
        this.excelData = this.excelData.slice(3, this.excelData.length)
        this.xlcData = []

        Promise.resolve(
          this.excelData = this.excelData.map(async (m: string[], index) => {

            const g = m[2];
            let gender = GENDER_DATA[0]
            if (g === 'ប' || g === 'ប្រុស') {
              gender = GENDER_DATA[0]
            }
            if (g === 'ស' || g === 'ស្រី') {
              gender = GENDER_DATA[1]
            }

            const fullName = m[1];
            if (!fullName) return;

            const gfn = fullName.toString()
            const gf = gfn && gfn != undefined ? gfn.trim().replace(/\s+/, " ") : '';
            const firstName = gf ? gf.split(' ').slice(1, 3).toString().replace(/,/g, " ").trim() : null;
            const lastName = gf ? gf.split(' ')[0].trim() : null;

            const dob = this.validDob(m[3])
            const dobText = m[3]

            const dateOfPassportExpiry = this.validDob(m[9])
            const dateOfPassportExpiryText = m[9]

            const dateOfArrival = this.validDob(m[10])
            const dateOfArrivalText = m[10]

            const visaExpiredDate = this.validDob(m[13])
            const visaExpiredDateText = m[13]

            const laborCardDate = this.validDob(m[15])
            const laborCardExpiredDateText = m[15]

            let isExist = false
            const passportNumber = m[8]
            if (passportNumber) {
              const eDocs = await this.ds.dbRef().collection("import_labor", ref => ref.where("passportNumber", "==", passportNumber)).get().toPromise();
              const eData = eDocs.docs.map((m: any) => { return { key: m.data().key } })
              isExist = eData.length > 0 ? true : false
            }

            const data = {
              isExist: isExist,
              full_name: fullName,
              last_name: lastName,
              first_name: firstName,
              gender: gender,
              dob: dob || null,
              dobText: dobText || null,
              nationality: m[4] || null,
              placeOfBirth: m[5] || null,
              occupation: m[6] || null,
              contact: m[7] || null,

              passportNumber: passportNumber || null,
              dateOfPassportExpiry: dateOfPassportExpiry || null,
              dateOfPassportExpiryText: dateOfPassportExpiryText,

              dateOfArrival: dateOfArrival || null,
              dateOfArrivalText: dateOfArrivalText,

              visaType: m[11] || null,
              visaNo: m[12] || null,
              visaExpiredDate: visaExpiredDate || null,
              visaExpiredDateText: visaExpiredDateText,

              laborCard: m[14] || null,
              laborCardDate: laborCardDate || null,
              laborCardExpiredDateText: laborCardExpiredDateText,

            }

            this.xlcData.push(data);

          })
        )

      }
      this.process = false;
    };
    reader.readAsBinaryString(target.files[0]);
  }

  // @action
  // async importLabor(items: Array<any>, f: any, user: any, callback) {
  //   this.loading = true;

  //   items.forEach(async (m, index) => {
  //     const batch = this.ds.batch()
  //     const ref = this.ds.firestore().collection("import_labor")

  //     const { search } = f
  //     const item = {
  //       ...m,
  //       key: this.ds.createId(),
  //       created_at: new Date(),
  //       date_key: ConvertService.dateKey(),
  //       created_by: user.key,
  //       status: DISPLAY_STATUS_OBJECT.ACTIVE,
  //       businessKey: search.key,

  //     }

  //     batch.set(ref.doc(item.key), item)

  //     await batch.commit().then(() => { })

  //     if (index + 1 === items.length) {
  //       this.loading = false;
  //       this.xlcData = [];
  //       callback(true, null);
  //     }

  //   })

  // }

}


